'use client';

import { getCookie } from 'cookies-next';
import { useRouter } from 'next/navigation';
import { Text } from '@/components/text';
import { PROMO_ID_COOKIE } from '@/constants';

export const NotAvailable = () => {
  const router = useRouter();
  const promoId = getCookie(PROMO_ID_COOKIE);

  // Check if there is a cookie (client side) and refresh route if there is
  if (promoId) {
    router.refresh();
  }

  return (
    <div className="rounded-rad-a bg-gray-50 p-b text-center max-md:py-c">
      <Text
        as="p"
        variant="body2"
        className="leading-none"
      >
        No offers available
      </Text>
    </div>
  );
};
